<template>
    <div class="input-group">
        <input :value="value" @keyup="refresh" class="form-control form-control-sm" ref="input" placeholder="YYYY-MM-DD" :name="name" autocomplete="off">
        <span class="input-group-btn">
            <button type="button" ref="button" class="btn btn-sm btn-blue"><i class="fa fa-calendar" aria-hidden="true"></i></button>
        </span>
    </div>


</template>

<script>
import Pikaday from "pikaday"
import "pikaday/css/pikaday.css"

export default {
    data() {
        return {
            picker: null
        }
    },
  props: {
    value: { required: true },
    format: { default: "YYYY-MM-DD" },
    name: { default: null },
    options: { default: {} },
    min: { default: null },
    max: { default: null },
  },
  watch: {
      value(value) {
          if (!value) {
              this.picker.setDate(null);
          }
      },
      min(val) {
          if (val) {
              this.picker.setMinDate(moment(this.min).toDate());
          } else {
              this.picker.setMinDate();
          }
      },
      max(val) {
          if (val) {
              this.picker.setMaxDate(moment(this.max).toDate());
          } else {
              this.picker.setMaxDate();
          }
      }
  },
  methods: {
      refresh() {
          if (!this.value) {
              this.picker.setDate('null');
          }
      }
  },
  mounted() {
    this.picker  = new Pikaday({
      field: this.$refs.input,
      format: this.format,
      keyboardInput: false,
      onSelect: () => {
        this.$emit("input", this.picker.toString())
      }
    });

    if (this.min) {
        this.picker.setMinDate(moment(this.min).toDate());
    }

    if (this.max) {
        this.picker.setMinDate(moment(this.max).toDate());
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/DatePicker.vue